import EmptyDataSVG from "../../../assets/icons/empty-data.svg"

const NoDataTableComponent = () => {
    return <div className="w-100-percent center-item" style={{ paddingTop: 50 }}>
        <img src={EmptyDataSVG} alt="" />
    </div>
}

export default NoDataTableComponent